import
  React
from 'react';

import {
  useHistory
} from 'react-router-dom';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  Text,
  VContainerH,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../constants';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

import {
  withScreenViewTagging
} from 'hocs';

import {
  handleUtagLinkEvent,
  useRedirectHandler
} from 'helpers';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const InsufficientAirtimeUI = props => {

  const history = useHistory();
  const redirectHandler = useRedirectHandler();

  InsufficientAirtimeUI.tagViewData = props.tagViewData;
  InsufficientAirtimeUI.pageName = props.pageName;

  return (

    <Card
      backgroundColor={CustomColors.White}
      borderRadius={'4px'}
      padding={'16px 15px 26px'}
      maxWidth={'350px'}
      boxSizing={'border-box'}
      width={'92%'}>

      <VContainerVH
        padding={'0 40px'}>
        <Text
          fontSize={'16px'}
          fontWeight={'bold'}
          color={CustomColors.Grey11}
          textAlign={'center'}
          padding={'0 0 16px'}>
          {'You don’t have enough airtime to proceed'}

        </Text>

        <Text
          fontSize={'14px'}
          color={CustomColors.Grey9}
          textAlign={'center'}
          padding={'0 0 16px'}>
          {'Stay in contact today and pay the next time you recharge.'}

        </Text>

      </VContainerVH>

      <PrimaryButton
        margin={'0 0 16px'}
        text={'Go to Airtime Advance'}
        onClick={() => {

          handleUtagLinkEvent({
            event_action: 'click',
            event_category: 'just for you: airtime advance',
            event_label: 'airtime advance'
          });

          if (!props.enableAirtimeAdvance) {

            redirectHandler(
              history.location,
              '/redirect?targetUrl=https://www.vodacom.co.za/vodacom/services/airtime-advance&isZeroRated=true',
              true
            );
          } else {

            history.push('/advance');
          }
        }}/>

      <SecondaryButton
        text={'Close'}
        onClick={props.onClose}/>

    </Card>
  );
};

InsufficientAirtimeUI.propTypes = {
  onClose: PropTypes.func,
  enableAirtimeAdvance: PropTypes.bool,
  pageName: PropTypes.string,
  tagViewData: PropTypes.object
};

InsufficientAirtimeUI.defaultProps = {
  onClose: () => {},
  enableAirtimeAdvance: false,
  pageName: '',
  tagViewData: {}
};

export const InsufficientAirtime = withScreenViewTagging(InsufficientAirtimeUI);